/* eslint-disable */
// 获取当前开发环境
// let service = process.env.NODE_ENV

// 设置api
let api = '/admin-v1/'
let nginx = '/rest/v2/'

export default {
	// 用户模块
	userList: `${api}user/list`,					// 用户列表 + 用户搜索
	userLoad: `${api}user/load`,					// 根据条件导出用户列表
	userDanaList: `${api}user/dana`,				// 大拿用户列表 + 用户搜索
	userUpLevel: `${api}user/up-level`,				// 修改用户级别
	userCreate: `${api}user/create`,				// 创建用户
	userInfo: `${api}user/info/`,					// 用户详情
	userToken: `${api}user/token`,					// 获取用户token信息
	userOrderList: `${api}user/order-list`,			// 用户订单列表
	userDeviceList: `${api}user/device-list`,		// 用户已绑定设备列表
	userDeviceCloudList: `${api}user/cloud-list`,	// 获取用户设备已开通云存储列表
	userOpenCloud: `${api}user/cloud`,				// 给指定用户、设备开通云存储套餐
    userCanCelSub: `${api}user/sub-cancel`,			// 取消用户指定设备已开通的云存储
    userThirdList: `${api}user/third-list`,			// 获取设备绑定的第三方账号列表
	userDelete: `${api}user/delete/`,				// 删除用户
	userUploadExcel: `${api}user/upload-excel`,		// excel导入用户
	userPushNum: `${api}user/pushnum`,				// 根据条件获取推送用户数量
	userPushMsg: `${api}user/pushmsg`,				// 根据条件给指定范围内用户推送自定义内容消息
	userUpDebug: `${api}user/up-debug`,				// 修改用户DEBUG标识
	userApplog: `${api}user/applog`,				// 获取APP上报的日志

	// 产品管理
	productList: `${api}product/list`,				// 获取产品列表
	productCreate: `${api}product/create`,			// 添加指定产品信息
	productInfo: `${api}product/info/`,				// 获取指定产品详情
	productPackgeList: `${api}product/pack-list/`,	// 获取指定产品关联的套餐列表
	productFuncList: `${api}product/func-list/`,	// 获取指定产品关联的功能列表
	productUpdate: `${api}product/update`,			// 更新指定产品数据
	productUpStatus: `${api}product/up-status`,		// 修改指定产品状态
	productUpSort: `${api}product/up-sort`,			// 修改指定产品状态
	productDelete: `${api}product/delete/`,			// 删除指定产品数据
	productSecret: `${api}product/secret/`,			// 查看指定产品Secret

	// 产品功能管理
	proFuncList: `${api}pro/func/list`,
	proFuncCreate: `${api}pro/func/create`,
	proFuncInfo: `${api}pro/func/info/`,
	proFuncUpdate: `${api}pro/func/update`,
	proFuncUpStatus: `${api}pro/func/up-status`,
	proFuncDelete: `${api}pro/func/delete/`,

	// 套餐管理
	packList: `${api}pack/list`,
	packCreate: `${api}pack/create`,
	packInfo: `${api}pack/info/`,
	packUpdate: `${api}pack/update`,
	packUpStatus: `${api}pack/up-status`,
	packDelete: `${api}pack/delete/`,

	// 出厂设备管理
	factoryList: `${api}factory/list`,				// 出厂设备列表 + 搜索
	factoryBatchUuid: `${api}factory/batch-uuid`,	// 批量生成出厂设备
	factoryRecordList: `${api}factory/record-list`,	// 设备出厂记录列表
	factoryDownExcel: `${api}factory/down-excel`,	// excel导出出厂设备数据

	// 已上线设备管理模块
	deviceList: `${api}device/list`,				// 已上线（被用户绑定过）设备列表 + 搜索
	deviceInfo: `${api}device/info`,				// 设备详情
	deviceLookKey: `${api}device/look-key`,			// 查看设备隐私信息
	deviceUserList: `${api}device/user-list`,		// 设备已绑定用户信息列表
	deviceUpOnline: `${api}device/up-online`,		// 修改设备在线状态
	deviceSendServer: `${api}device/send-server`,	// 通知设备P2P服务地址
	deviceDelBind: `${api}device/del-bind`,			// 解除用户与设备的绑定关系
	deviceDelAleax: `${api}device/del-aleax`,		// 删除Aleax存储的设备用户关系
	deviceUpStreamParam: `${api}device/up-stream-param`,	// 修改设备的stream_param字段内容并通知aleax
	deviceUpgrade: `${api}device/upgrade`,			// 触发设备升级
	deviceNewUuid: `${api}device/new-uuid`,			// 更新设备为新的uuid
	tuyaDeviceList: `${api}t-device/list`,			// 已上线（被用户绑定过）设备列表 + 搜索
	tuyaDeviceInfo: `${api}t-device/info`,			// 设备详情

	// 涂鸦接口
	tuyaDevices: `${api}tuya/devices`,	 // 获取涂鸦设备列表
	deviceLog: `${api}tuya/devlog`,	 	 // 获取涂鸦设备日志
	userUid: `${api}tuya/user`,	 		 // 获取涂鸦用户uid

	// 大拿设备模块管理
	danaDeviceList: `${api}dana/list`,						// 大拿设备列表 + 搜索
	danaDeviceUpRole: `${api}dana/up-role`,					// 修改单个指定id的设备升级权限
	danaDeviceUpRoles: `${api}dana/up-roles`,				// 修改多个指定id的设备升级权限
	danaDeviceWhereUpRoles: `${api}dana/where-up-roles`,	// 根据条件修改多个设备升级权限
	danaDeviceUploadExcel: `${api}dana/upload-excel`,		// excel导入大拿设备
	danaDeviceRestore: `${api}dana/restore`,				// 重置大拿设备
	danaFacilityList: `${api}dana/facility`,				// 获取大拿出厂设备列表

	// 版本管理（√）
	versionList: `${api}version/index`,
	versionCreate: `${api}version/create`,
	versionInfo: `${api}version/info`,
	versionUpdate: `${api}version/update`,
	versionUpStatus: `${api}version/up-status`,
	versionDelete: `${api}version/delete/`,

	// APP及型号管理
	appList: `${api}app/list`,				// 获取App列表
	appCreate: `${api}app/create`,			// 添加指定App信息
	appInfo: `${api}app/info/`,				// 获取指定App详情
	appSecret: `${api}app/secret/`,			// 获取指定App的Secret
	appUpdate: `${api}app/update`,			// 更新指定App数据
	appDelete: `${api}app/delete/`,			// 删除指定App数据
	appSign: `${api}app/sign`,				// 获取可用签名信息

	// App极光配置管理
	jpushList: `${api}app/jpush/list`,				// 获取App极光配置列表
	jpushCreate: `${api}app/jpush/create`,			// 添加指定App极光配置信息
	jpushInfo: `${api}app/jpush/info/`,				// 获取指定App极光配置详情
	jpushUpdate: `${api}app/jpush/update`,			// 更新指定App极光配置数据
	jpushDelete: `${api}app/jpush/delete/`,			// 删除指定App极光配置数据

	// App极光配置管理
	fcmList: `${api}app/fcm/list`,					// 获取App的FCM配置列表
	fcmCreate: `${api}app/fcm/create`,				// 添加指定App的FCM配置信息
	fcmInfo: `${api}app/fcm/info/`,					// 获取指定App的FCM配置详情
	fcmUpdate: `${api}app/fcm/update`,				// 更新指定App的FCM配置数据
	fcmDelete: `${api}app/fcm/delete/`,				// 删除指定App的FCM配置数据

	// App的APNS配置管理
	apnsList: `${api}app/apns/list`,				// 获取App的APNS配置列表
	apnsCreate: `${api}app/apns/create`,			// 添加指定App的APNS配置信息
	apnsInfo: `${api}app/apns/info/`,				// 获取指定App的APNS配置详情
	apnsUpdate: `${api}app/apns/update`,			// 更新指定App的APNS配置数据
	apnsDelete: `${api}app/apns/delete/`,			// 删除指定App的APNS配置数据

	// App的个推配置管理
	getuiList: `${api}app/getui/list`,				// 获取App的APNS配置列表
	getuiCreate: `${api}app/getui/create`,			// 添加指定App个推配置信息
	getuiInfo: `${api}app/getui/info/`,				// 获取指定App个推配置详情
	getuiUpdate: `${api}app/getui/update`,			// 更新指定App个推配置数据
	getuiDelete: `${api}app/getui/delete/`,			// 删除指定App个推配置数据

	// App友盟推送配置管理
	upushList: `${api}app/upush/list`,				// 获取App友盟推送配置列表
	upushCreate: `${api}app/upush/create`,			// 添加指定App友盟推送配置信息
	upushInfo: `${api}app/upush/info/`,				// 获取指定App友盟推送配置详情
	upushUpdate: `${api}app/upush/update`,			// 更新指定App友盟推送配置数据
	upushDelete: `${api}app/upush/delete/`,			// 删除指定App友盟推送配置数据

	// 订单管理
	orderList: `${api}order/list`,
	orderInfo: `${api}order/info/`,
	orderCount: `${api}order/count`,
	orderMap: `${api}order/map`,
	orderLoad: `${api}order/load`,

	// 消息管理
	msgList: `${api}msg/list`,
	msgDeviceList: `${api}msg/dev-list`,
	msgDeviceFile: `${api}msg/dev-file/`,
	msgDelete: `${api}msg/delete/`,

	// 邮件记录管理
	emailList: `${api}email/list`,

	// 分享管理
	shareList: `${api}share/list`,

	// 日志管理
	logList: `${api}log/list`,
	logEventList: `${api}log/event/list`,
	logEventInfo: `${api}log/event/info/`,
	logMongoList: `${api}log/mongo-list`,
	logMongoEventList: `${api}log/event/mongo-list`,
	logMongoEventInfo: `${api}log/event/mongo-info`,

	// 统计模块
	statisticsUser: `${api}statistics/user`,						// 用户地图分布统计
	statisticsDevice: `${api}statistics/device`,					// 设备地图分布统计
	statisticsDeviceNum: `${api}statistics/device-num`,				// 设备数量统计
	statisticsModelCountry: `${api}statistics/model-country`,		// 根据型号+国家统计设备数量
	statisticsDeviceTotal: `${api}statistics/device-total`,			// 设备总数
	statisticsUsStateDevice: `${api}statistics/us-state-device`,	// 美国各州设备数统计

	// 反馈类型管理
	feedbackTypeList: `${api}feedback/type/index`,		// 获取反馈类型列表
	feedbackTypeCreate: `${api}feedback/type/create`,	// 添加反馈类型数据
	feedbackTypeInfo: `${api}feedback/type/info/`,		// 获取指定反馈类别详情
	feedbackTypeUpdate: `${api}feedback/type/update`,	// 修改反馈类别数据
	feedbackTypeUpSort: `${api}feedback/type/up-sort`,	// 修改反馈类别序号
	feedbackTypeDelete: `${api}feedback/type/delete/`,	// 删除反馈类别数据

	// 用户反馈消息管理
	feedbackList: `${api}feedback/list`,				// 获取反馈消息列表
	feedbackInfo: `${api}feedback/info/`,				// 获取指定反馈消息详情
	feedbackUpStatus: `${api}feedback/up-status`,		// 修改指定反馈消息状态

	// 反馈快捷推送消息管理
	feedbackMsgList: `${api}feedback/msg/list`,			// 获取反馈快捷推送消息列表
	feedbackMsgInfo: `${api}feedback/msg/info`,			// 获取指定快捷消息详情
	feedbackMsgEdit: `${api}feedback/msg/edit`,			// 编辑反馈快捷推送消息
	feedbackMsgDelete: `${api}feedback/msg/delete`,		// 删除反馈快捷推送消息

	// 后台菜单管理模块
	menuList: `${api}menu/list`,					// 菜单列表
	menuInfo: `${api}menu/info/`,					// 菜单详情
	menuCreate: `${api}menu/add`,					// 创建菜单
	menuUpdate: `${api}menu/up`,					// 修改菜单
	menuUpSort: `${api}menu/sort`,					// 修改菜单排序
	menuDelete: `${api}menu/del/`,					// 删除菜单
	menuFunc: `${api}menu/menu-func`,				// 获取菜单及菜单下的功能列表

	// 后台功能管理模块
	funcList: `${api}func/list`,					// 功能列表
	funcInfo: `${api}func/info/`,					// 功能详情
	funcCreate: `${api}func/add`,					// 创建功能
	funcUpdate: `${api}func/up`,					// 修改功能
	funcUpSort: `${api}func/sort`,					// 修改功能排序
	funcUpRoute: `${api}func/route`,				// 修改功能路由地址
	funcDelete: `${api}func/del/`,					// 删除功能

	// 后台角色管理模块
	roleList: `${api}role/list`,					// 角色列表
	roleInfo: `${api}role/info/`,					// 角色详情
	roleCreate: `${api}role/add`,					// 创建角色
	roleUpdate: `${api}role/up`,					// 修改角色
	roleDelete: `${api}role/del/`,					// 删除角色

	// 后台管理员管理模块
	adminerList: `${api}admin/list`,				// 管理员列表
	adminerInfo: `${api}admin/info/`,				// 管理员详情
	adminerCreate: `${api}admin/add`,				// 创建管理员
	adminerUpdate: `${api}admin/up`,				// 修改管理员
	adminerDelete: `${api}admin/del/`,				// 删除管理员
	adminerDisable: `${api}admin/disable`,			// 禁用管理员
	adminerLifeban: `${api}admin/lifeban/`,			// 解除管理员禁用状态
	adminerOwnerInfo: `${api}admin/owninfo/`,		// 后台管理员获取自己的信息
	adminerOwnerUpdate: `${api}admin/ownup`,		// 后台管理员修改自己的信息

	// 后台管理员登录、注销
	adminLogin: `${api}admin/login`,				// 管理员登录
	adminLogout: `${api}admin/logout`,				// 注销登录

	// 获取后台日志列表
	adminLogList: `${api}admin/log`,				// 获取后台日志列表

	// 文件管理
	fileList: `${api}file/list`,					// 获取文件列表
	fileInfo: `${api}file/info/`,					// 获取文件详情
	fileDelete: `${api}file/delete/`,				// 删除文件
	fileCertCreate: `${api}file/cert/create`,		// 上传证书文件
	fileCertUpdate: `${api}file/cert/update`,		// 修改证书文件

	// s3文件操作
	s3DownPreSign: `${api}file/s3/down-preSign`,	// 获取s3文件预签名

	// 服务器管理
	serverBaseList: `${api}server/base/list`,				// 获取服务器基础配置列表
	serverBaseInfo: `${api}server/base/info/`,				// 服务器基础配置详情
	serverBaseCreate: `${api}server/base/create`,			// 创建服务器基础配置
	serverBaseUpdate: `${api}server/base/update`,			// 修改服务器基础配置
	serverBaseDelete: `${api}server/base/delete/`,			// 删除服务器基础配置
	serverAccountList: `${api}server/account/list`,			// 获取服务器基础配置列表
	serverAccountInfo: `${api}server/account/info/`,		// 服务器基础配置详情
	serverAccountCreate: `${api}server/account/create`,		// 创建服务器基础配置
	serverAccountUpdate: `${api}server/account/update`,		// 修改服务器基础配置
	serverAccountDelete: `${api}server/account/delete/`,	// 删除服务器基础配置

	// 国家数据管理
	countryList: `${api}country/list`,				// 获取国家数据列表
	countryInfo: `${api}country/info/`,				// 国家数据详情
	countryCreate: `${api}country/create`,			// 创建国家数据
	countryUpdate: `${api}country/update`,			// 修改国家数据
	countryDelete: `${api}country/delete/`,			// 删除国家数据

	// 友情链接数据管理
	linkList: `${api}link/list`,				// 获取国家数据列表
	linkInfo: `${api}link/info`,				// 国家数据详情
	linkCreate: `${api}link/create`,			// 创建国家数据
	linkDelete: `${api}link/delete`,			// 删除国家数据

	// 后台版本日志管理模块
	adminVersionList: `${api}version/admin/list`,		// 版本日志列表
	adminVersionInfo: `${api}version/admin/info/`,		// 版本日志详情
	adminVersionCreate: `${api}version/admin/create`,	// 创建版本日志
	adminVersionUpdate: `${api}version/admin/update`,	// 修改版本日志
	adminVersionDelete: `${api}version/admin/delete/`,	// 删除版本日志

	// 云存储服务接口
	cloudVideoInfo: `${nginx}server/filelist_get`,	 // 获取s3云存储信息列表V1
	cloudVideoList: `${nginx}server/fileinfo_fetch`, // 获取s3云存储信息列表V2
	nginxAwsSigined: `${nginx}packput_presignurl`,	 // s3上传文件生成预签名

	// 质保，免费试用申请
	applyList:`${api}apply/list`,
	applyStatus:`${api}apply/status`,

}



// WEBPACK FOOTER //
// ./src/axios/url.js